import React, { useState, useEffect } from 'react';

const ExitIntent: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [hasTriggered, setHasTriggered] = useState(false);

    useEffect(() => {
        // Check if already shown in this session
        const sessionTriggered = sessionStorage.getItem('exitIntentShown');

        // DEBUG: Uncomment to reset for testing
        // sessionStorage.removeItem('exitIntentShown');

        if (sessionTriggered) {
            console.log('Exit Intent: blocked by session storage');
            setHasTriggered(true);
            return;
        }

        const handleMouseLeave = (e: MouseEvent) => {
            console.log('Mouse leave:', e.clientY);
            if (e.clientY < 20 && !hasTriggered) {
                console.log('Exit Intent: Triggered!');
                setIsVisible(true);
                setHasTriggered(true);
                sessionStorage.setItem('exitIntentShown', 'true');
            }
        };

        document.addEventListener('mouseleave', handleMouseLeave);
        return () => document.removeEventListener('mouseleave', handleMouseLeave);
    }, [hasTriggered]);

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-[#021226]/90 backdrop-blur-sm animate-fade-in"
                onClick={() => setIsVisible(false)}
            ></div>

            {/* Modal Content */}
            <div className="relative bg-white rounded-[2rem] max-w-lg w-full p-8 md:p-10 shadow-2xl animate-bounce-in text-center border-4 border-[#FF5C00]/20">
                <button
                    onClick={() => setIsVisible(false)}
                    className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 transition-colors"
                >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
                </button>

                <div className="w-20 h-20 bg-orange-50 rounded-full flex items-center justify-center mx-auto mb-6 animate-pulse">
                    <span className="text-4xl">💡</span>
                </div>

                <h2 className="text-3xl font-black text-[#021226] mb-3 leading-tight">
                    Before You Go...
                </h2>

                <p className="text-slate-600 mb-8 font-medium">
                    See how leading Indian retailers are using 3D to boost conversions. Get a free <span className="text-[#FF5C00] font-bold">Digital Transformation Consultation</span> custom-tailored for your brand.
                </p>

                <a
                    href="#contact-us"
                    onClick={() => setIsVisible(false)}
                    className="block w-full py-4 bg-[#FF5C00] hover:bg-[#E65200] text-white font-black text-sm uppercase tracking-widest rounded-xl shadow-xl shadow-orange-500/30 hover:shadow-orange-500/50 transition-all transform hover:-translate-y-1"
                >
                    Get Expert Advice
                </a>

                <button
                    onClick={() => setIsVisible(false)}
                    className="mt-4 text-xs font-bold text-slate-400 hover:text-slate-600 uppercase tracking-wider"
                >
                    No thanks, I'm happy with my current sales
                </button>
            </div>
        </div>
    );
};

export default ExitIntent;
